import Vue from 'vue'
import {
  addGroupingInResponseData,
  LinkCellRenderer,
  MultiLinkCellRenderer,
  autoResize,
  getPinnedRowData
} from '@/helpers/renderHelpers'
import {
  addColIdToColumns,
  handlerResponse,
  SumRows
} from '@/helpers/commonHelpers'
// import {
//   translateColumns
// } from '@/helpers/translate-helper'
import gridProps from '@/gridProps'

export default {
  namespaced: true,
  state: {
    contracts: [],
    contractsList: [],
    pricesColumns: [],
    columns: [],
    documents: [],
    pinnedRowData: [],
    comments: [],
    bindPackages: [],
    prices: [],
    pricesCount: 0,
    unbindPackages: [],
    unbindPackagesOrdersCount: 0,
    bindPackagesColumns: [
      { field: 'movement_name', headerName: 'Acceptance name', cellRenderer: 'MovementLink' },
      {
        headerName: 'Delivered', children: [
          { field: 'delivered_nominal', headerName: 'nom' },
          { field: 'delivered_stock', headerName: 'stock' }]
      },
      { field: 'ordered', headerName: 'Ordered' },
      { field: 'measure_type', headerName: 'Measure type' }
    ],
    unbindPackagesColumns: [
      { field: 'package_nr', headerName: 'Package №' },
      { field: 'package_name', headerName: 'Package name' },
      { field: 'delivered_stock', headerName: 'Delivered stock' },
      { field: 'measure_type', headerName: 'Measure type' }
    ],
    contractsCount: null,
    contractTypes: ['direct', 'exchange'],
    contractStatuses: ['active', 'completed'],
    gridOptions: {
      rowGroupPanelShow: 'always',
      enableFilter: true,
      enableColResize: true,
      animateRows: true,
      enableSorting: true,
      rowSelection: 'multiple',
      aggFuncs: {
        'SumRows': SumRows
      },
      components: {
        'PriceListLink': LinkCellRenderer('id', '/price-list/'),
        'BuyerLink': LinkCellRenderer('buyer_id', '/partners/'),
        'SellerLink': LinkCellRenderer('seller_id', '/partners/'),
        'SuppliersLink': MultiLinkCellRenderer('shippers', '/partners/', 'name', 'id')
      },
      onRowDataChanged () {
        if (this.rowData && this.rowData.length) {
          autoResize(this)
        } else {
          this.api && this.api.hideOverlay()
          this.api && this.api.showNoRowsOverlay()
        }
      }
    },
    gridName: 'purchase_price_lists'
  },
  getters: {
    contracts: (state) => state.contracts,
    gridOptions (state) {
      return { ...state.gridOptions, ...gridProps }
    },
    bindPckgsGridOptions (state) {
      return {
        treeData: true,
        animateRows: true,
        groupDefaultExpanded: -1,
        components: {
          'MovementLink': LinkCellRenderer('movement_id', '/operation/')
        },
        getDataPath: function (data) {
          return data.order_nr
        },
        autoGroupColumnDef: {
          headerName: 'Purchase Order',
          cellRendererParams: {
            suppressCount: true
          }
        }
      }
    },
    unbindPckgsGridOptions (state) {
      return {
        treeData: true,
        animateRows: true,
        groupDefaultExpanded: -1,
        getDataPath: function (data) {
          return data.movement_name
        },
        autoGroupColumnDef: {
          headerName: 'Operation name',
          cellRendererParams: {
            suppressCount: true
          }
        }
      }
    }
  },
  mutations: {
    setData (state, data) {
      if (data.data) {
        const { translateColumnsProperly } = data
        state.contracts = addGroupingInResponseData(data.data.results)
        state.columns = translateColumnsProperly(addColIdToColumns(data.used_columns))
        state.contractsCount = data.data.count
        state.pinnedRowData = getPinnedRowData(data.total, 'name', 'value')
      } else {
        state.contracts = data
        state.pinnedRowData = data
      }
      if (data.grid_name) {
        state.gridName = data.grid_name
      }
    },
    setColumns (state, data) {
      state.columns = data
      console.log(data, state.gridOptions)
      // state.gridOptions.api.setColumnDefs(data)
    },
    setPriceLists (state, data) {
      state.contractsList = data
    },
    setDistibutedPackages (state, data) {
      state.bindPackages = data
    },
    setUndistibutedPackages (state, data) {
      state.unbindPackagesOrdersCount = data.length
      state.unbindPackages = data
    },
    setCommentsList (state, data) {
      state.comments = data
    },
    setDocumentsList (state, data) {
      state.documents = data
    },
    setPricesData (state, data) {
      if (data.data) {
        const { translateColumnsProperly } = data
        state.prices = addGroupingInResponseData(data.data.results)
        state.pricesColumns = translateColumnsProperly(addColIdToColumns(data.used_columns))
        //adding unique keys for 'Suppliers' column. Needed for correct row grouping
        state.pricesColumns = state.pricesColumns.map(e => {
          if (e.field && e.field === 'shippers') {
            e.keyCreator = function (params) {
              if (params) {
                return params.value.map(e => e.id).join('')
              }
            }
          }
          return e
        })
        state.pricesCount = data.data.count
        state.pinnedRowData = getPinnedRowData(data.total, 'name', 'value')
      } else {
        state.prices = data
        state.pinnedRowData = data
      }
      if (data.grid_name) {
        state.gridName = data.grid_name
      }
    }
  },
  actions: {
    loadPrices (store, payLoad) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay()
      }
      Vue.http.get('purchase/search_for_prices/', { params: payLoad })
        .then(response => response.json())
        .then(data => {
          const { translateColumnsProperly } = payLoad
          store.commit('setPricesData', { ...data, translateColumnsProperly })
        })
    },
    loadPriceList (store, payLoad) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay()
      }
      const { translateColumnsProperly } = payLoad

      Vue.http.get('purchase/search_for_price_lists/', { params: payLoad })
        .then(response => response.json())
        .then(data => {
          store.commit('setData', { ...data, translateColumnsProperly })
        })
    },
    loadPriceLists (store, payLoad) {
      Vue.http.get('purchase/price_lists/ids/', { params: payLoad })
        .then(response => response.json())
        .then(data => {
          store.commit('setPriceLists', data)
        })
    },
    loadDistributedPackages (store, payLoad) {
      Vue.http.get(`purchase/price_lists/${payLoad}/distribution/per_order/`)
        .then(response => response.json())
        .then(data => {
          store.commit('setDistibutedPackages', data)
        })
    },
    loadUndistributedPackages (store, payLoad) {
      Vue.http.get(`purchase/price_lists/${payLoad}/distribution/per_operation/`)
        .then(response => response.json())
        .then(data => {
          store.commit('setUndistibutedPackages', data)
        })
    },
    loadBindedPackages (store, payLoad) {
      Vue.http.get(`purchase/price_lists/${payLoad}/distribution/per_order/`)
        .then(response => response.json())
        .then(data => {
          store.commit('setDistibutedPackages', data)
        })
    },
    loadCommentsList (store, payLoad) {
      Vue.http.get(`purchase/price_lists/${payLoad.id}/comments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setCommentsList', data)
        })
    },
    loadDocumentsList (store, payLoad) {
      Vue.http.get(`purchase/price_lists/${payLoad.id}/attachments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setDocumentsList', data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/purchases/priceLists.js